function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import metadataThunkHelper from 'invision-core/src/api/metadata.thunk.helper';
import { LANGUAGE_HEADER } from 'invision-core/src/api/constants';
export var FETCH_PRODUCT = {
  BEGIN: 'FETCH_PRODUCT_BEGIN',
  SUCCESS: 'FETCH_PRODUCT_SUCCESS',
  FAILURE: 'FETCH_PRODUCT_FAILURE'
};
export var getProductMetadataPromise = function getProductMetadataPromise(dispatch, productId, customerLanguage) {
  return metadataThunkHelper(dispatch, Object.values(FETCH_PRODUCT), {
    url: "Product/Id/".concat(productId),
    headers: _defineProperty({}, LANGUAGE_HEADER, customerLanguage)
  }, {
    productId: productId
  });
};
export var getProductMetadata = function getProductMetadata(productId, language) {
  return function (dispatch) {
    return getProductMetadataPromise(dispatch, productId, language);
  };
};